import strings from 'strings';
import { EntityType } from 'UI/constants/entityTypes';

export const COPIES = strings.ai.generators.prospectingAssistant.drawer.metaData;

export const COUNT_TEMPLATE_BY_TYPE = {
  [EntityType.Candidate]: COPIES.contactsFound,
  [EntityType.Company]: COPIES.companiesFound
};
